import React from 'react';
import { SectionHeader } from '../../components';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaClock, FaWhatsapp } from 'react-icons/fa';

const ContactInfoSection = () => {
  const contactInfo = [
    {
      icon: <FaEnvelope className="contact-icon" />,
      title: 'Email',
      value: 'growthvibe2406@gmail.com',
      link: 'mailto:growthvibe2406@gmail.com',
      description: 'Send us an email for any questions'
    },
    {
      icon: <FaPhone className="contact-icon" />,
      title: 'Phone',
      value: '+91 78610 83648',
      link: 'tel:+917861083648',
      description: 'Call us for a free consultation'
    },
    {
      icon: <FaWhatsapp className="contact-icon" />,
      title: 'WhatsApp',
      value: '+91 78610 83648',
      link: 'https://wa.me/917861083648',
      description: 'Chat with us on WhatsApp'
    },
    {
      icon: <FaMapMarkerAlt className="contact-icon" />,
      title: 'Address',
      value: 'Surat, Gujarat, India',
      link: 'https://maps.app.goo.gl/8r7tPJNXPRzC4q9i7',
      description: 'Visit our office in Surat'
    },
    {
      icon: <FaClock className="contact-icon" />,
      title: 'Business Hours',
      value: 'Mon - Fri: 9:00 AM - 6:00 PM',
      link: null,
      description: 'We are available Monday to Friday'
    }
  ];

  return (
    <section className="section-padding contact-info-section">
      <div className="container">
        <SectionHeader
          subtitle="Contact Information"
          title="Get In Touch"
          description="We'd love to hear from you. Here's how you can reach us."
        />
        <div className="row">
          {contactInfo.map((info, index) => (
            <div key={index} className="col-lg-4 col-md-6 mb-4">
              <div className="contact-info-card">
                <div className="contact-info-icon">
                  {info.icon}
                </div>
                <div className="contact-info-content">
                  <h5 className="contact-info-title">{info.title}</h5>
                  <p className="contact-info-value">{info.value}</p>
                  <p className="contact-info-description">{info.description}</p>
                  {info.link && (
                    <a 
                      href={info.link} 
                      className="contact-info-link"
                      target={info.link.startsWith('http') ? '_blank' : '_self'}
                      rel={info.link.startsWith('http') ? 'noopener noreferrer' : ''}
                    >
                      {info.title === 'WhatsApp' ? 'Open WhatsApp' : 
                       info.title === 'Email' ? 'Send Email' :
                       info.title === 'Phone' ? 'Call Now' :
                       info.title === 'Address' ? 'View on Map' : 'Contact'}
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection;
